// Pick the club a shooter should be registered under from a Rubic person record.
//
// Rubic returns two club lists per person:
//   memberships:         [{ organizationId, isActiveAthlete }]  - every club the person is a member of
//   branchOrganizations: [{ branchId, organizationId }]         - which club the shooter SHOOTS FOR
//                                                                per branch (gren), per NSF's
//                                                                "Tilgang til eksternt API" doc.
//
// A shooter can be a member of several clubs and can represent different clubs in
// different branches (pistol vs rifle). The represented club for the branch is the
// one that matters for start lists and result reporting, so it wins over the plain
// membership list. Mirrors backend/lib/rubic-club.js - keep the two in sync.
//
// Resolution order:
//   1. branchOrganizations entry whose branchId matches the given branchId
//   2. if every branchOrganizations entry points at the same club, that club
//   3. first membership with isActiveAthlete, then the first membership
//
// Returns the organizationId, or '' when nothing usable is present.
export function pickRubicClubOrgId({ memberships, branchOrganizations, branchId } = {}) {
    const branches = Array.isArray(branchOrganizations)
        ? branchOrganizations.filter(b => b && b.organizationId)
        : [];
    if (branchId) {
        const match = branches.find(b => b.branchId === branchId);
        if (match) return match.organizationId;
    }
    if (branches.length > 0) {
        const distinct = new Set(branches.map(b => b.organizationId));
        if (distinct.size === 1) return branches[0].organizationId;
    }
    const members = Array.isArray(memberships)
        ? memberships.filter(m => m && m.organizationId)
        : [];
    const active = members.find(m => m.isActiveAthlete);
    if (active) return active.organizationId;
    return members.length > 0 ? members[0].organizationId : '';
}

// The Rubic branch (gren) GUID for a convention weapon class ('fin', 'grov', ...), looked up
// in conventionStore.disciplineMap. When the weapon class is unknown or unmapped and every
// discipline in the map belongs to the same branch (pistol-only product today), that branch
// is returned. Returns '' when the branch cannot be determined.
export function branchIdForWeaponClass(disciplineMap, weaponClass) {
    const map = Array.isArray(disciplineMap) ? disciplineMap : [];
    const key = String(weaponClass || '').trim().toLowerCase();
    if (key) {
        const found = map.find(d => d && d.branchId && String(d.key || '').toLowerCase() === key);
        if (found) return found.branchId;
    }
    const distinct = new Set(map.map(d => d && d.branchId).filter(Boolean));
    if (distinct.size === 1) return distinct.values().next().value;
    return '';
}
